<template>

  <v-select
      prepend-icon="move_up"
      :items="getItems"
      v-model="item"
      :label="$t('delivery.stockTransaction.labels.operation')"
      :loading="loading"
      :error="hasInputErrors('operation')"
      :error-messages="getInputErrors('operation')"
      color="secondary"
      item-color="secondary"
      clearable
      @change="$emit('change')"
      :multiple="multiple"
  ></v-select>

</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


export default {
  name: "OperationCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {
      type: [String, Array],
    },
    multiple: {type:Boolean, default: false}
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    getItems() {
      return [
        {text: this.$t('delivery.stockOperation.ADD'), value: 'ADD'},
        {text: this.$t('delivery.stockOperation.REMOVE'), value: 'REMOVE'},
        {text: this.$t('delivery.stockOperation.MOVE'), value: 'MOVE'},
        {text: this.$t('delivery.stockOperation.SOLD'), value: 'SOLD'},
        {text: this.$t('delivery.stockOperation.RESTORE'), value: 'RESTORE'},
      ]
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    }
  }
}
</script>

<style scoped>

</style>

